var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddContact({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8E7BFB33-E098-45F0-A74F-E8BA14D36548") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assign-To-Do",
    transform: "translate(-663.000000, -457.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(472.505322, 205.567287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(176.115601, 245.608928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-contact",
    transform: "translate(14.896230, 6.375000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.179308,2.55502862 L11.0715031,1.66283359 L12.6486554,3.23998587 L15.2666813,0.621836641 L16.1588763,1.51403167 L12.6486554,5.02425266 L10.179308,2.55502862 Z M15.1925885,4.26470953 C15.8178771,5.42566029 16.1498767,6.73023511 16.1498767,8.08597213 C16.1498767,10.2429217 15.3099534,12.2706714 13.7848263,13.7959217 C12.2596992,15.3210489 10.2318263,16.15 8.075,16.15 C5.91805038,16.15 3.89030076,15.3210489 2.36505038,13.7959217 C0.839923275,12.2706714 0,10.2429217 0,8.08597213 C0,5.92914582 0.839923275,3.90127289 2.36505038,2.37614579 C3.89030076,0.85101871 5.91805038,0 8.075,0 C8.92897749,0 9.76261335,0.143254183 10.5529771,0.396969466 L9.52208933,1.42798054 C9.05546526,1.32664236 8.5714584,1.27276794 8.075,1.27276794 C4.31809082,1.27276794 1.2616725,4.32918626 1.2616725,8.08597213 C1.2616725,9.80465266 1.90175495,11.3766271 2.95544999,12.5765351 C3.32209199,10.9360157 4.45900266,9.58323742 5.96551411,8.91886831 C5.33652711,8.34535839 4.94116031,7.51973588 4.94116031,6.60350076 C4.94116031,4.87557405 6.34695001,3.46966107 8.075,3.46966107 C9.80292672,3.46966107 11.2087164,4.87545077 11.2087164,6.60350076 C11.2087164,7.51973588 10.8134729,8.34535839 10.1844859,8.91886831 C11.6908741,9.58323742 12.827908,10.9360157 13.1944267,12.5765351 C14.2482451,11.3765038 14.8882042,9.80465266 14.8882042,8.08597213 C14.8882042,7.05804314 14.6588988,6.08263245 14.2494779,5.20782024 L15.1925885,4.26470953 Z M8.075,8.47554465 C9.10724389,8.47554465 9.94704389,7.63574465 9.94704389,6.60350076 C9.94704389,5.5711336 9.10724389,4.73133357 8.075,4.73133357 C7.04263284,4.73133357 6.20283281,5.5711336 6.20283281,6.60350076 C6.20283281,7.63574465 7.04263284,8.47554465 8.075,8.47554465 L8.075,8.47554465 Z M8.075,14.8992996 C9.56055345,14.8992996 10.9363855,14.4209637 12.0572694,13.6107515 C11.998587,11.4648973 10.2347851,9.73721718 8.075,9.73721718 C5.91521488,9.73721718 4.15128969,11.4648973 4.09273055,13.6107515 C5.21361449,14.4209637 6.58932327,14.8992996 8.075,14.8992996 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddContact);
export default __webpack_public_path__ + "static/media/add-contact.201d49ce52c936eb264193c55633e852.svg";
export { ForwardRef as ReactComponent };